class CashLimitStatus {
    constructor(serverStatus) {
        this.serverStatus = serverStatus;
    }

    translate(t) {
        return t(`cash-limits.statuses.${this.serverStatus.toLowerCase()}`);
    }
}

export const CREATED = new CashLimitStatus('CREATED');

export const CANCELLED = new CashLimitStatus('CANCELLED');

export const getCashLimitStatus = (serverStatus) => {
    let result = null;
    switch (serverStatus) {
        case 'CREATED':
            result = CREATED;
            break;
        case 'CANCELLED':
            result = CANCELLED;
            break;
        default:
            throw new Error(`Unknown cash limit status: ${serverStatus}`);
    }
    return result;
};

export const getAllCashLimitStatuses = () => [
    CREATED,
    CANCELLED,
];
